module.exports = __webpack_public_path__ + "images/psp/RvStorage/rvStorageComparison/outdoor.svg";